// Tokens and Values
export const STABLECOIN_DECIMALS = 6;
export const PRICE_IMPACT_WARNING_THRESHOLD = 0.002;

// Transactions
export const QUEUE_LOCALSTORAGE_KEY = 'transaction-list.v2';

// Misc.
export const UNIVERSAL_IMPACT_POOL_VANITY_URL = 'universal';
export const ORGANIZATION_ADDITION_FORM_URL = 'https://endaoment.typeform.com/new-org';

export const QUERY_STATE_KEY_INVITE_REFERRAL_CODE = 'ref';

export const INTERCOM_APP_ID = 'd1d9jukk';

export const COPY_SHARE_TEXT = 'Copy URL to clipboard';

export const ORG_PAGE_SUBPROJECT_MINI_THRESHOLD = 4;

export const TIME_ONE_MINUTE_IN_SECONDS = 60;
export const TIME_ONE_HOUR_IN_SECONDS = 3600;
export const TIME_ONE_DAY_IN_SECONDS = 86_400;
export const DEBOUNCE_MS = 1000;

export const NTEE_CODE_TO_NAME = {
  A: 'Arts, Culture & Humanities',
  B: 'Education',
  C: 'Environment',
  D: 'Animal-Related',
  E: 'Health Care',
  F: 'Mental Health & Crisis Intervention',
  G: 'Voluntary Health Associations & Medical Disciplines',
  H: 'Medical Research',
  I: 'Crime & Legal-Related',
  J: 'Employment',
  K: 'Food, Agriculture & Nutrition',
  L: 'Housing & Shelter',
  M: 'Public Safety, Disaster Preparedness & Relief',
  N: 'Recreation & Sports',
  O: 'Youth Development',
  P: 'Human Services',
  Q: 'International, Foreign Affairs & National Security',
  R: 'Civil Rights, Social Action & Advocacy',
  S: 'Community Improvement & Capacity Building',
  T: 'Philanthropy, Voluntarism & Grantmaking Foundations',
  U: 'Science & Technology',
  V: 'Social Science',
  W: 'Public & Societal Benefit',
  X: 'Religion-Related',
  Y: 'Mutual & Membership Benefit',
  Z: 'Unknown / Others',
} as const;

export const WALLET_CONNECT_PROJECT_ID = 'ec99ea0b84e190d058c72067c9de3c11';

export const ENDAOMENT_EIN = '84-4661797';

/*
 * On the 2026 Messaging Framework (endaoment-specs BizDev/messaging-framework).
 * The previous description led with "built for decentralized finance", which the
 * framework's Avoid list rules out. Crypto is not the identity.
 *
 * Fallback for both marketing sites and overview, so it stays generic.
 *
 * The framework's top line is "The giving layer for modern wealth", still a
 * candidate there. This one says "Giving Tools for Every Portfolio" so the
 * title and the home headline say the same thing: two top lines on one page
 * is the worse problem. "Tools" is the review round's word and is not in the
 * framework yet; an issue under PJ-2057 carries the site's wording back to it.
 * Change the framework first rather than this string on its own: it is the
 * fallback for both marketing sites and overview too.
 */
export const DEFAULT_META_TITLE = 'Giving Tools for Every Portfolio | Endaoment';
export const DEFAULT_META_DESCRIPTION =
  'Technology and services for turning investments into impact. Open a donor-advised fund and give cash, stocks, or complex assets.';
export const DEFAULT_META_IMAGE =
  'https://storage.googleapis.com/endaoment-static/site-assets/endaoment-og-image-fw25.png';

export const AUM_RATE = 316887386n;

export const RPC_URLS: Record<number, [string, ...Array<string>]> = {
  // Mainnets
  1: [
    'https://mainnet.infura.io/v3/510c5afa18eb4eb9b611f010b805c393',
    'https://eth-mainnet.g.alchemy.com/v2/ao2D0tkhGEKpa2l-kyzmBhxyXm1Md9my',
    'https://mainnet.gateway.tenderly.co/4zmtwDeAz3MODjVA9Lj2Lz',
  ],
  10: [
    'https://optimism-mainnet.infura.io/v3/510c5afa18eb4eb9b611f010b805c393',
    'https://opt-mainnet.g.alchemy.com/v2/uqpk8cgLUX7oimlg-lQ-uOruCN6mkpr8',
    'https://optimism.gateway.tenderly.co/4zmtwDeAz3MODjVA9Lj2Lz',
  ],
  8453: [
    'https://base-mainnet.g.alchemy.com/v2/TgMmNhKZcm8fQMGiq_XJ7UIAtqfq74IO',
    'https://base.gateway.tenderly.co/4zmtwDeAz3MODjVA9Lj2Lz',
    'https://indulgent-wandering-mountain.base-mainnet.quiknode.pro/3383d83de8323da271bfbc01bd220e703e4729b8',
  ],
  // Testnets
  31337: ['http://127.0.0.1:8545'],
  31338: ['http://127.0.0.1:8546'],
  84532: [
    'https://base-sepolia.g.alchemy.com/v2/7rM_WmTTXQMLGe5CfSZkX7GHtOoe7yYF',
    'https://base-sepolia.gateway.tenderly.co/4zmtwDeAz3MODjVA9Lj2Lz',
  ],
  11155111: [
    'https://sepolia.infura.io/v3/510c5afa18eb4eb9b611f010b805c393',
    'https://eth-sepolia.g.alchemy.com/v2/PiTxkzC2yCaX4AoUXVZ4zKUPlYlOAoiN',
    'https://sepolia.gateway.tenderly.co/4zmtwDeAz3MODjVA9Lj2Lz',
  ],
  11155420: [
    'https://optimism-sepolia.infura.io/v3/510c5afa18eb4eb9b611f010b805c393',
    'https://opt-sepolia.g.alchemy.com/v2/_pXzgK5f94Tx8jbLHhBSOoEWxCxzS7Xb',
    'https://optimism-sepolia.gateway.tenderly.co/4zmtwDeAz3MODjVA9Lj2Lz',
  ],
};
